import React, { ReactNode } from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { FilterProvider as MapComponentsFilterProvider } from '@innovyze/map-components';

export interface FilterProviderProps {
	children: ReactNode;
}

/**
 * Feature-flag–driven FilterProvider wrapper.
 *
 * In Esri mode filter state lives in Redux so no context provider is needed —
 * children are rendered directly. In Mapbox mode the legacy context provider
 * from `@innovyze/map-components` is used.
 *
 * When `info360-platform-esri-map` is enabled the provider is a no-op;
 * otherwise the legacy `@innovyze/map-components` FilterProvider is used.
 */
const FilterProvider = ({ children }: FilterProviderProps): JSX.Element => {
	const isEsri = Boolean(useIsFeatureEnabled('info360-platform-esri-map'));

	if (isEsri) {
		return <>{children}</>;
	}

	return (
		<MapComponentsFilterProvider>{children}</MapComponentsFilterProvider>
	);
};

export default FilterProvider;
